<template>
  <div>
    <b-modal
      v-model="showModal"
      ref="modal"
      centered
      size="lg"
      class="alert-modal"
      hide-header-close
      content-class="modal-register"
      footer-class="pt-0 border-0"
    >
      <template #modal-header>
        <div class="d-flex justify-content-center w-100 align-items-center">
          <div class="modal-title">
            {{ isAdd ? "เพิ่มวิธีรับเงิน" : "วิธีการรับเงิน" }}
          </div>
        </div>
      </template>
      <div v-if="!isAdd">
        <div v-for="(payment, index) in paymentList" :key="`payment+${index}`">
          <div
            class="d-flex justify-content-between px-3 mb-2 w-100 refundtype-container can-hover"
            @click="selectPayment(payment)"
          >
            <span v-if="payment.is_default" class="text-success f-14 mt-2"
              >Default</span
            >
            <p class="mb-0 text-center flex-grow-1 py-3">
              {{ payment.return_payment_name }}
              <span v-if="payment.return_payment_id !== 2"
                >| {{ payment.return_bank_name }} เลขบัญชี
                {{ payment.bank_account_number }}</span
              >
            </p>
            <div class="py-3">
              <font-awesome-icon
                icon="trash-alt"
                title="delete-btn"
                class="pointer ml-3"
                :class="{ 'text-danger': !payment.is_default }"
                @click.stop="
                  deletePayment(payment.id, false, payment.is_default)
                "
              />
            </div>
          </div>
        </div>
        <div
          class="d-block   d-flex justify-content-center p-2"
          :class="{ 'can-hover': limit !== paymentList.length }"
        >
          <b-button
            class="btn-modal btn-hover px-5 ml-1"
            @click="addRefund"
            :disabled="limit == paymentList.length"
            >เพิ่ม ({{ paymentList.length }} / {{ limit }})</b-button
          >
        </div>
      </div>

      <div v-else>
        <b-tabs v-model="tabIndex">
          <b-tab title="ข้อมูลการรับเงิน">
            <b-row class="mt-3">
              <b-col cols="12" md="6">
                <b-row>
                  <b-col cols="12" md="7">
                    <InputSelect
                      :options="payments"
                      textField="name"
                      valueField="id"
                      v-model="form.return_payment_id"
                      :isValidate="$v.form.return_payment_id.$error"
                      :v="$v.form.return_payment_id"
                      @onDataChange="(val) => (form.return_payment_id = val)"
                    >
                      <template v-slot:option-first>
                        <b-form-select-option :value="null" disabled>
                          -- เลือกประเภทการรับเงิน --
                        </b-form-select-option>
                      </template>
                    </InputSelect>
                  </b-col>
                  <b-col cols="12" md="7">
                    <InputSelect
                      v-if="
                        form.return_payment_id && form.return_payment_id < 2
                      "
                      :options="banks"
                      textField="name"
                      valueField="id"
                      validateText="กรุณาเลือกธนาคาร"
                      v-model="form.return_bank_id"
                      :isValidate="$v.form.return_bank_id.$error"
                      :v="$v.form.return_bank_id"
                      @onDataChange="(val) => (form.return_bank_id = val)"
                    >
                      <template v-slot:option-first>
                        <b-form-select-option :value="0" disabled>
                          -- เลือกธนาคาร --
                        </b-form-select-option>
                      </template>
                    </InputSelect>
                  </b-col>
                  <b-col cols="12">
                    <InputText
                      v-model="form.bank_name"
                      v-if="
                        form.return_payment_id && form.return_payment_id < 2
                      "
                      placeholder="ชื่อบัญชีธนาคาร"
                      :isValidate="$v.form.bank_name.$error"
                      :v="$v.form.bank_name"
                    ></InputText>
                  </b-col>
                  <b-col cols="12" class="mt-2">
                    <InputText
                      @onKeypress="isNumber"
                      :maxLength="form.return_payment_id == 4 ? 13 : 10"
                      v-if="
                        form.return_payment_id && form.return_payment_id !== 2
                      "
                      v-model="form.bank_account_number"
                      :placeholder="
                        form.return_payment_id == 1
                          ? 'เลขบัญชีธนาคาร'
                          : 'เลข Promptpay'
                      "
                      :isValidate="$v.form.bank_account_number.$error"
                      :v="$v.form.bank_account_number"
                    ></InputText>
                    <span
                      v-if="
                        $v.form.bank_account_number.$error &&
                        $v.form.bank_account_number.$model
                      "
                      class="text-error"
                    >
                      {{ validateText }}</span
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-form-checkbox
              class="mt-3"
              v-model="form.is_default"
              :value="true"
              :unchecked-value="false"
            >
              Default
            </b-form-checkbox>
          </b-tab>
        </b-tabs>
      </div>
      <template #modal-footer="">
        <div class="d-flex justify-content-between w-100 my-0">
          <b-button
            variant="close"
            class="btn-modal btn-hover mr-1"
            :class="{ 'w-50': isAdd, 'w-100': !isAdd }"
            @click="hide()"
            :disabled="isLoading"
          >
            ยกเลิก
          </b-button>
          <b-button
            variant="primary-color"
            class="btn-modal btn-hover w-50 ml-1"
            @click="save"
            v-if="isAdd"
            :disabled="isLoading"
          >
            ยืนยัน
          </b-button>
        </div>
      </template>
    </b-modal>
    <ModalAlertConfirm
      ref="modalAlertConfirm"
      :msg="confirmMessage.msg"
      :text="confirmMessage.text"
      @confirm="(val) => deletePayment(val, true)"
    />
  </div>
</template>

<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import { minLength, maxLength, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import { requiredIf } from "vuelidate/lib/validators";
import { minValue } from "vuelidate/lib/validators";
import ModalAlertConfirm from "@/components/modal/alert/ModalAlertConfirm.vue";
function bankLengthValidator() {
  const id = this.form.return_payment_id;
  if (id === 4) return { min: minLength(13), max: maxLength(13) };
  if (id === 2) return { min: () => true, max: () => true };
  return { min: minLength(10), max: maxLength(10) };
}
export default {
  components: {
    InputText,
    InputSelect,
    ModalAlertConfirm,
  },
  props: { userGuid: { require: true, type: String } },
  data() {
    return {
      isLoading: false,
      showModal: false,
      isAdd: false,
      tabIndex: 0,
      form: {
        user_guid: "",
        return_payment_id: null,
        return_bank_id: 0,
        bank_name: "",
        bank_account_number: "",
        is_default: false,
      },
      paymentList: [],
      payments: [],
      banks: [],
      filter: {
        search: "",
        page: 1,
        take: 20,
      },
      limit: 0,
      validateText: "",
      confirmMessage: {
        text: "",
        msg: "",
      },
      deleteId: null,
    };
  },
  validations: {
    form: {
      return_payment_id: { required },
      return_bank_id: {
        required: requiredIf(function (item) {
          return this.form.return_payment_id == 1;
        }),
        minValue: function (item) {
          return (
            (item > 0 && this.form.return_payment_id == 1) ||
            this.form.return_payment_id !== 1
          );
        },
      },
      bank_name: {
        required: requiredIf(function (item) {
          return this.form.return_payment_id == 1;
        }),
      },
      bank_account_number: {
        required: requiredIf(function (item) {
          return this.form.return_payment_id !== 2;
        }),
        // maxLength: function (item) {
        //   if (this.form.return_payment_id == 4 && item.length > 13) {
        //     this.validatText =
        //       "กรุณากรอกเลขพร้อมเพย์บัตรประชาชนไม่เกิน 13 หลัก";
        //     return false;
        //   } else if (
        //     (this.form.return_payment_id == 1 ||
        //       this.form.return_payment_id == 3) &&
        //     item.length > 10
        //   ) {
        //     this.validatText =
        //       "กรุณากรอกเลขบัญชี 10 หลัก";
        //     return false;
        //   } else {
        //     return true;
        //   }
        // },
        checkMin: function () {
          let message = [
            { id: 1, message: "กรุณากรอกเลขบัญชี 10 หลัก", number: 10 },
            {
              id: 3,
              message: "กรุณากรอกเลขพร้อมเพย์เบอร์มือถือ 10 หลัก",
              number: 10,
            },
            {
              id: 4,
              message: "กรุณากรอกเลขพร้อมเพย์บัตรประชาชน 13 หลัก",
              number: 13,
            },
          ];
          let condition = message.find((item) => {
            return item.id == this.form.return_payment_id;
          });
          if (
            condition &&
            this.form.bank_account_number.length < condition.number
          ) {
            this.validateText = condition.message;
            return false;
          }
          return true;
        },
      },
    },
  },

  computed: {
    ...mapGetters({
      limitOptionalTel: "getLimitTelephone",
    }),
  },

  methods: {
    async show() {
      await this.getUserReturnList();
      await this.getUserReturnBank();
      await this.getUserReturnPayment();
      this.showModal = true;
    },
    addRefund() {
      this.isAdd = true;
    },
    async getUserReturnList() {
      await this.axios(
        `${this.$baseUrl}/UserReturnPayment/list/${this.userGuid}`
      ).then(async (data) => {
        if (data.result == 1) {
          this.paymentList = data.detail.datas;
          this.limit = data.detail.limit;
        }
      });
    },
    async getUserReturnPayment() {
      await this.axios
        .post(`${this.$baseUrl}/UserReturnPayment/ReturnPayment`, this.filter)
        .then(async (data) => {
          if (data.result == 1) {
            this.payments = data.detail.datas;
          }
        });
    },
    async getUserReturnBank() {
      await this.axios
        .post(`${this.$baseUrl}/UserReturnPayment/ReturnBank`, this.filter)
        .then(async (data) => {
          if (data.result == 1) {
            this.banks = data.detail.datas;
          }
        });
    },
    async deletePayment(id, isDelete, isDefault) {
      if (isDefault) {
        return;
      }
      if (!isDelete) {
        this.confirmMessage = {
          msg: "ยืนยันการทำรายการ",
          text: "หลังจากยืนยันแล้วจะไม่สามารถแก้ไขได้",
        };
        this.deleteId = id;
        this.$refs.modalAlertConfirm.show();
      } else {
        console.log(this.deleteId);
        let res = await this.axios.delete(
          `${this.$baseUrl}/UserReturnPayment/${this.deleteId}`
        );
        if (!res.result) {
          this.errorAlert(res.message);
        }
        await this.getUserReturnList();
      }
    },
    hide() {
      this.$v.form.$reset();
      this.form = {
        user_guid: "",
        return_payment_id: null,
        return_bank_id: 0,
        bank_name: "",
        bank_account_number: "",
        is_default: false,
      };
      this.validateText = "";
      if (this.isAdd) {
        this.isAdd = false;
      } else this.showModal = false;
    },

    async save() {
      if (this.isAdd) {
        console.log(this.$v);
        this.$v.form.$touch();
        if (this.$v.form.$error) {
          return;
        } else {
          let payload = {
            ...this.form,
            user_guid: this.userGuid,
          };
          let res = await this.axios.post(
            `${this.$baseUrl}/UserReturnPayment`,
            payload
          );
          if (res.result) {
            this.successAlert();
            await this.getUserReturnList();
            this.isAdd = false;
          } else this.errorAlert(res.message);
        }
      } else {
      }
    },
    isNumber: function (e) {
      const key = e.key;

      if (!/^\d$/.test(key)) {
        e.preventDefault();
      }
    },
    selectPayment(payment) {
      this.$emit("selectPayment", payment);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  color: #fff;
  width: 100%;
  background-color: var(--primary-color);
}
::v-deep .modal-body {
  padding: 1rem 1rem;
}
.btn-primary .modal-body {
  margin: auto;
  text-align: center;
}
::v-deep .modal-register {
  .btn-link {
    border-color: transparent !important;
    background-color: transparent !important;
    text-decoration: underline !important;
    padding: 0;
    color: #f7f7f7 !important;
  }

  .icon-delete {
    width: 20px;
    height: 20px;
  }
  .register-box {
    background: #f7f7f7;
    border: 1px solid #d8dbe0;

    max-height: 500px;
    overflow: auto;
  }
  .nav-tabs {
    .nav-item {
      margin-bottom: 0px;
    }
    .nav-link {
      border: 1px solid white !important;
      border-bottom: 3px solid white !important;
      font-weight: 600;
      background: white !important;
      color: #333 !important;
    }
    .nav-link.active {
      border: 1px solid var(--secondary-color) !important;
      border-bottom: 3px solid var(--primary-color) !important;
      color: var(--primary-color) !important;
    }
  }
}

@media (max-width: 768px) {
  ::v-deep .div-input {
    width: 100%;
  }
  ::v-deep .modal-dialog {
    margin: 0px;
    max-width: 100vw !important;
    .modal-content {
      width: 100vw;
      height: 100vh;
      .modal-body {
        overflow-y: auto;
      }
    }
  }
}
.text-link {
  right: 0;
  position: absolute;
  margin-right: 20px;
}

.refundtype-container {
  border: 1px dashed var(--primary-color) !important;
  border-radius: 6px;
  // transition: background-color 0.2s ease, border-color 0.2s ease;
}

.refundtype-container.can-hover:hover {
  border-color: var(--secondary-color);
  background-color: var(--secondary-color);
  cursor: pointer;
}

// .refundtype-container:hover {
//   border-color: var(--secondary-color);
//   background-color: var(--secondary-color);
//   cursor: pointer;
// }

.btn-width {
  // width:30px;
  // height: 30px;
}
</style>
